import {
  EoDropdownConfig,
  IEoDropdownConfig,
} from '../eo-dropdown/eo-dropdown.model';
import { City } from './city.model';

export interface IEoCityDropdownConfig extends IEoDropdownConfig<City> {
  type?: any;
  url?: string;
  prefectureId?: string | number | null;
}

export class EoCityDropdownConfig
  extends EoDropdownConfig<City>
  implements IEoCityDropdownConfig
{
  override type?: any;
  url?: string;
  prefectureId?: string | number | null;

  constructor();
  constructor(obj: IEoCityDropdownConfig);
  constructor(obj?: IEoCityDropdownConfig) {
    super(obj as IEoCityDropdownConfig);
    this.type = 'cityDropdown';
    this.url = obj?.url;
    this.prefectureId = obj?.prefectureId;
  }
}
